import styled from "styled-components";

export const AssignmentsWrapper = styled.div`
  display: grid;
  grid-gap: 21px;
  margin-top: 38px;
`